export default [
  {
    path: "/settings/account-profile",
    name: "AccountProfile",
    component: () => import("@/views/3pl/Settings/AccountProfile/index"),
  },
  // {
  //   path: "/settings/account-owner/edit",
  //   name: "AccountOwnerEdit",
  //   component: () => import("@/views/3pl/Settings/AccountOwner/Edit"),
  // },
  {
    path: "/settings/account-owner/edit-security",
    name: "EditSecuritySettings",
    component: () =>
      import("@/views/3pl/Settings/AccountOwner/EditSecuritySettings"),
  },
  // {
  //   path: "/settings/organization-information/edit",
  //   name: "OrganizationInformationEdit",
  //   component: () =>
  //     import("@/views/3pl/Settings/OrganizationInformation/Edit"),
  // },
];
